import { render, staticRenderFns } from "./SellersSalesForm.vue?vue&type=template&id=10977225"
import script from "./SellersSalesForm.vue?vue&type=script&lang=js"
export * from "./SellersSalesForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports